export default __webpack_public_path__ + "static/media/delete-white.a309d8d2.svg";